import useSWR from 'swr';
import { categoryDataFetcher } from './api';
import { API } from '../constants';
import { SWR_CONFIG } from './config';
import { CategoryKind, Nullable, PropertiesResponse } from '../types';

export const useProperties = (categoryId: Nullable<CategoryKind>) => {
  const key = categoryId ? ([API.PROPERTIES, categoryId] as const) : null;
  const { data, isLoading } = useSWR<PropertiesResponse>(key, categoryDataFetcher, SWR_CONFIG);

  return { data, isLoading };
};
